import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vShow as _vShow, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-47801cce"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { class: "pm-page-header" };
const _hoisted_5 = { class: "pm-header-left" };
const _hoisted_6 = { class: "pm-header-icon" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "pm-page-title" }, "Precios y Promociones"),
    /*#__PURE__*/ _createElementVNode("p", { class: "pm-page-subtitle" }, "Gestión de márgenes, costos y descuentos programados")
], -1 /* HOISTED */));
const _hoisted_8 = { class: "pm-toolbar" };
const _hoisted_9 = { class: "pm-tabs" };
const _hoisted_10 = { class: "pm-controls" };
const _hoisted_11 = { class: "pm-search-wrap" };
const _hoisted_12 = {
    key: 0,
    class: "pm-config-row"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "pm-config-label" }, "% Mayor:", -1 /* HOISTED */));
const _hoisted_14 = ["disabled"];
const _hoisted_15 = { class: "pm-config-row" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "pm-config-label" }, "Ver PVD:", -1 /* HOISTED */));
const _hoisted_17 = /*#__PURE__*/ _createStaticVNode("<option value=\"7\" data-v-47801cce>7 Días</option><option value=\"15\" data-v-47801cce>15 Días</option><option value=\"30\" data-v-47801cce>30 Días</option><option value=\"60\" data-v-47801cce>60 Días</option><option value=\"90\" data-v-47801cce>90 Días</option>", 5);
const _hoisted_22 = [
    _hoisted_17
];
const _hoisted_23 = { class: "pm-controls" };
const _hoisted_24 = { class: "pm-table-card" };
const _hoisted_25 = { class: "pm-table" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Producto", -1 /* HOISTED */));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Código", -1 /* HOISTED */));
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Equivalente", -1 /* HOISTED */));
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "center" } }, "Stock", -1 /* HOISTED */));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Último Costo", -1 /* HOISTED */));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Costo Promedio", -1 /* HOISTED */));
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "center" } }, "% Detal", -1 /* HOISTED */));
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Precio Detal", -1 /* HOISTED */));
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Precio Aliado", -1 /* HOISTED */));
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Precio Mayor", -1 /* HOISTED */));
const _hoisted_36 = { style: { "text-align": "center" } };
const _hoisted_37 = { key: 0 };
const _hoisted_38 = {
    colspan: "11",
    class: "text-center py-8"
};
const _hoisted_39 = { class: "loading-state" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando precios...", -1 /* HOISTED */));
const _hoisted_41 = { key: 1 };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "11",
    class: "text-center py-4 text-muted"
}, "No se encontraron productos.", -1 /* HOISTED */));
const _hoisted_43 = [
    _hoisted_42
];
const _hoisted_44 = { style: { "font-weight": "600", "color": "#334155", "font-size": "0.85rem", "line-height": "1.2" } };
const _hoisted_45 = {
    class: "attribute-badge",
    style: { "color": "#64748b", "background": "#f1f5f9", "font-family": "monospace" }
};
const _hoisted_46 = {
    key: 0,
    class: "status-badge active",
    style: { "background": "#dbeafe", "color": "#1e40af", "border": "1px solid #bfdbfe", "font-size": "0.75rem" }
};
const _hoisted_47 = {
    key: 1,
    style: { "color": "#94a3b8", "font-style": "italic", "font-size": "0.8rem" }
};
const _hoisted_48 = { style: { "text-align": "center" } };
const _hoisted_49 = {
    class: "type-badge-retail",
    style: { "background": "#e0e7ff", "color": "#4338ca", "padding": "2px 6px", "font-size": "0.75rem", "font-weight": "700" }
};
const _hoisted_50 = { style: { "text-align": "right", "font-family": "monospace", "font-size": "0.85rem" } };
const _hoisted_51 = { style: { "text-align": "right", "font-family": "monospace", "font-size": "0.85rem", "font-weight": "700", "color": "#0f172a", "background": "#f8fafc" } };
const _hoisted_52 = { style: { "display": "flex", "align-items": "center", "justify-content": "flex-end", "gap": "4px" } };
const _hoisted_53 = ["onClick"];
const _hoisted_54 = { style: { "text-align": "center", "background": "#f0fdf4" } };
const _hoisted_55 = {
    key: 0,
    style: { "display": "flex", "justify-content": "center", "align-items": "center" }
};
const _hoisted_56 = ["onUpdate:modelValue", "onChange", "disabled"];
const _hoisted_57 = {
    key: 1,
    style: { "color": "#94a3b8", "font-style": "italic", "font-size": "0.7rem" }
};
const _hoisted_58 = { style: { "text-align": "right" } };
const _hoisted_59 = { style: { "display": "flex", "flex-direction": "column", "align-items": "flex-end" } };
const _hoisted_60 = {
    key: 0,
    style: { "background": "#fee2e2", "color": "#b91c1c", "font-size": "0.65rem", "padding": "0px 4px", "border-radius": "3px", "font-weight": "bold", "margin-bottom": "2px" }
};
const _hoisted_61 = {
    key: 1,
    style: { "font-weight": "700", "color": "#15803d", "font-family": "monospace", "font-size": "0.85rem" }
};
const _hoisted_62 = { style: { "text-align": "right" } };
const _hoisted_63 = { style: { "font-family": "monospace", "font-weight": "600", "color": "#0d9488", "background": "#ccfbf1", "padding": "2px 4px", "border-radius": "4px", "font-size": "0.85rem" } };
const _hoisted_64 = { style: { "text-align": "right" } };
const _hoisted_65 = { style: { "font-family": "monospace", "font-weight": "600", "color": "#b45309", "background": "#fef3c7", "padding": "2px 4px", "border-radius": "4px", "font-size": "0.85rem" } };
const _hoisted_66 = { style: { "text-align": "center", "background": "#f8fafc" } };
const _hoisted_67 = {
    key: 0,
    class: "pm-pagination"
};
const _hoisted_68 = ["disabled"];
const _hoisted_69 = { class: "pm-page-info" };
const _hoisted_70 = ["disabled"];
const _hoisted_71 = { class: "pm-total" };
const _hoisted_72 = { class: "pm-table-card" };
const _hoisted_73 = { class: "pm-promo-toolbar" };
const _hoisted_74 = {
    class: "pm-search-wrap",
    style: { "position": "relative" }
};
const _hoisted_75 = {
    key: 0,
    class: "ac-dropdown",
    style: { "width": "400px" }
};
const _hoisted_76 = ["onMousedown"];
const _hoisted_77 = { class: "pm-check-label" };
const _hoisted_78 = { class: "pm-table" };
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Tipo", -1 /* HOISTED */));
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Aplicado A", -1 /* HOISTED */));
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "center" } }, "Descuento", -1 /* HOISTED */));
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Fecha Inicio", -1 /* HOISTED */));
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Fecha Fin", -1 /* HOISTED */));
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", null, "Estado", -1 /* HOISTED */));
const _hoisted_85 = {
    key: 0,
    class: "pm-actions-col"
};
const _hoisted_86 = { key: 0 };
const _hoisted_87 = {
    colspan: "8",
    class: "pm-empty-cell"
};
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "color": "#94a3b8", "margin-top": "8px" } }, "Cargando promociones...", -1 /* HOISTED */));
const _hoisted_89 = { key: 1 };
const _hoisted_90 = {
    colspan: "8",
    class: "pm-empty-cell"
};
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "color": "#94a3b8", "margin-top": "8px" } }, "No hay promociones registradas.", -1 /* HOISTED */));
const _hoisted_92 = {
    key: 0,
    class: "pm-badge pm-badge-blue"
};
const _hoisted_93 = {
    key: 1,
    class: "pm-badge pm-badge-pink"
};
const _hoisted_94 = {
    key: 2,
    class: "pm-badge pm-badge-green"
};
const _hoisted_95 = { style: { "display": "flex", "align-items": "center", "gap": "8px" } };
const _hoisted_96 = { class: "pm-apply-name" };
const _hoisted_97 = { style: { "text-align": "center" } };
const _hoisted_98 = { class: "pm-discount-pill" };
const _hoisted_99 = { style: { "font-weight": "600", "color": "#475569" } };
const _hoisted_100 = { style: { "font-weight": "600", "color": "#475569" } };
const _hoisted_101 = {
    key: 0,
    class: "pm-status pm-status-green"
};
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "pm-dot" }, null, -1 /* HOISTED */));
const _hoisted_103 = {
    key: 1,
    class: "pm-status pm-status-gray"
};
const _hoisted_104 = {
    key: 2,
    class: "pm-status pm-status-purple"
};
const _hoisted_105 = {
    key: 3,
    class: "pm-status pm-status-red"
};
const _hoisted_106 = {
    key: 0,
    class: "pm-actions-col"
};
const _hoisted_107 = ["onClick", "title"];
const _hoisted_108 = ["onClick"];
const _hoisted_109 = ["onClick"];
const _hoisted_110 = {
    key: 0,
    class: "pm-pagination"
};
const _hoisted_111 = ["disabled"];
const _hoisted_112 = { class: "pm-page-info" };
const _hoisted_113 = ["disabled"];
const _hoisted_114 = { class: "pm-total" };
const _hoisted_115 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_116 = { class: "modal-window" };
const _hoisted_117 = {
    class: "modal-header",
    style: { "background": "white", "border-bottom": "1px solid #f1f5f9", "padding": "24px 32px", "display": "flex", "justify-content": "space-between", "align-items": "center" }
};
const _hoisted_118 = { style: { "display": "flex", "align-items": "center", "gap": "16px" } };
const _hoisted_119 = { style: { "width": "48px", "height": "48px", "border-radius": "12px", "background": "#eff6ff", "display": "flex", "align-items": "center", "justify-content": "center", "color": "#3b82f6" } };
const _hoisted_120 = { style: { "margin": "0", "font-size": "1.3rem", "font-weight": "700", "color": "#0f172a", "letter-spacing": "-0.02em" } };
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "margin": "2px 0 0", "font-size": "0.85rem", "color": "#64748b", "font-weight": "500" } }, "Configura los detalles del descuento programado", -1 /* HOISTED */));
const _hoisted_122 = { class: "form-scroll-area" };
const _hoisted_123 = { class: "premium-form-card" };
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-badge-premium" }, "Configuración del Descuento", -1 /* HOISTED */));
const _hoisted_125 = { class: "grid-layout-premium" };
const _hoisted_126 = {
    class: "input-group-premium full-col",
    style: { "margin-bottom": "0.5rem" }
};
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { style: { "margin-bottom": "0.75rem", "color": "#475569", "font-size": "0.85rem" } }, "¿A qué se aplica este descuento?", -1 /* HOISTED */));
const _hoisted_128 = { style: { "display": "grid", "grid-template-columns": "repeat(3, 1fr)", "gap": "0.75rem" } };
const _hoisted_129 = { style: { "display": "flex", "align-items": "center", "gap": "8px" } };
const _hoisted_130 = ["disabled"];
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.85rem", "font-weight": "700", "color": "#1e293b" } }, "Producto"),
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.65rem", "color": "#64748b" } }, "SKU único")
], -1 /* HOISTED */));
const _hoisted_132 = { style: { "display": "flex", "align-items": "center", "gap": "8px" } };
const _hoisted_133 = ["disabled"];
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.85rem", "font-weight": "700", "color": "#1e293b" } }, "Equivalente"),
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.65rem", "color": "#64748b" } }, "Grupo técnico")
], -1 /* HOISTED */));
const _hoisted_135 = { style: { "display": "flex", "align-items": "center", "gap": "8px" } };
const _hoisted_136 = ["disabled"];
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.85rem", "font-weight": "700", "color": "#1e293b" } }, "Marca"),
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.65rem", "color": "#64748b" } }, "Toda la marca")
], -1 /* HOISTED */));
const _hoisted_138 = {
    class: "input-group-premium full-col",
    style: { "position": "relative" }
};
const _hoisted_139 = ["disabled"];
const _hoisted_140 = {
    key: 0,
    class: "ac-dropdown"
};
const _hoisted_141 = ["onMousedown"];
const _hoisted_142 = { class: "input-group-premium full-col" };
const _hoisted_143 = { style: { "position": "relative", "display": "flex", "align-items": "center" } };
const _hoisted_144 = ["disabled"];
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { style: { "position": "absolute", "right": "16px", "font-weight": "900", "color": "#ef4444", "font-size": "1.2rem" } }, "%", -1 /* HOISTED */));
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("small", { style: { "color": "#64748b", "margin-top": "4px", "display": "block" } }, "Indique el porcentaje de descuento que se aplicará al precio de venta.", -1 /* HOISTED */));
const _hoisted_147 = { class: "input-group-premium" };
const _hoisted_148 = { class: "input-group-premium" };
const _hoisted_149 = {
    class: "input-group-premium full-col",
    style: { "margin-top": "10px" }
};
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.95rem", "font-weight": "800", "color": "#1e293b" } }, "Promoción Activa"),
    /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.75rem", "color": "#64748b" } }, "Habilita el cálculo automático de precios con este descuento")
], -1 /* HOISTED */));
const _hoisted_151 = { style: { "padding": "24px 32px", "background": "#f8fafc", "border-top": "1px solid #f1f5f9", "display": "flex", "justify-content": "flex-end", "gap": "12px" } };
const _hoisted_152 = ["disabled"];
const _hoisted_153 = { key: 1 };
const _hoisted_154 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_155 = {
    class: "modal-window",
    style: { "max-width": "900px", "width": "95%" }
};
const _hoisted_156 = {
    class: "modal-header",
    style: { "background": "white", "border-bottom": "1px solid #f1f5f9", "padding": "20px 32px", "display": "flex", "justify-content": "space-between", "align-items": "center" }
};
const _hoisted_157 = { style: { "display": "flex", "align-items": "center", "gap": "16px" } };
const _hoisted_158 = { style: { "width": "44px", "height": "44px", "border-radius": "10px", "background": "#f8fafc", "display": "flex", "align-items": "center", "justify-content": "center", "color": "#64748b" } };
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { style: { "margin": "0", "font-size": "1.2rem", "font-weight": "700", "color": "#0f172a" } }, "Historial de Costos", -1 /* HOISTED */));
const _hoisted_160 = { style: { "margin": "0", "font-size": "0.8rem", "color": "#64748b" } };
const _hoisted_161 = {
    class: "modal-body bg-light-premium p-6",
    style: { "max-height": "70vh", "overflow-y": "auto" }
};
const _hoisted_162 = {
    key: 0,
    class: "text-center py-12"
};
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando historial...", -1 /* HOISTED */));
const _hoisted_164 = {
    key: 1,
    class: "text-center py-12"
};
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "color": "#64748b" } }, "No se encontraron registros de cambios para este producto.", -1 /* HOISTED */));
const _hoisted_166 = {
    key: 2,
    class: "pm-table-card",
    style: { "border-radius": "12px", "border": "1px solid #e2e8f0", "box-shadow": "none" }
};
const _hoisted_167 = { class: "pm-table" };
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha"),
        /*#__PURE__*/ _createElementVNode("th", null, "Tipo"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Costo Anterior"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "center" } }),
        /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Costo Nuevo"),
        /*#__PURE__*/ _createElementVNode("th", null, "Origen / Documento"),
        /*#__PURE__*/ _createElementVNode("th", null, "Usuario")
    ])
], -1 /* HOISTED */));
const _hoisted_169 = { style: { "white-space": "nowrap" } };
const _hoisted_170 = { style: { "font-size": "0.8rem", "font-weight": "600" } };
const _hoisted_171 = { style: { "font-size": "0.7rem", "color": "#94a3b8" } };
const _hoisted_172 = { style: { "text-align": "right", "font-family": "monospace", "font-size": "0.85rem", "color": "#64748b" } };
const _hoisted_173 = { style: { "text-align": "center", "color": "#94a3b8" } };
const _hoisted_174 = { style: { "text-align": "right", "font-family": "monospace", "font-size": "0.85rem", "font-weight": "700", "color": "#0f172a" } };
const _hoisted_175 = { style: { "font-size": "0.85rem", "font-weight": "600", "color": "#334155" } };
const _hoisted_176 = { style: { "font-size": "0.7rem", "color": "#64748b" } };
const _hoisted_177 = { style: { "display": "flex", "align-items": "center", "gap": "6px" } };
const _hoisted_178 = { style: { "width": "24px", "height": "24px", "border-radius": "50%", "background": "#f1f5f9", "display": "flex", "align-items": "center", "justify-content": "center", "font-size": "0.7rem", "font-weight": "700", "color": "#475569" } };
const _hoisted_179 = { style: { "font-size": "0.8rem" } };
const _hoisted_180 = { style: { "padding": "16px 32px", "background": "white", "border-top": "1px solid #f1f5f9", "display": "flex", "justify-content": "flex-end" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_TagIcon = _resolveComponent("TagIcon");
    const _component_BadgePercentIcon = _resolveComponent("BadgePercentIcon");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_SaveIcon = _resolveComponent("SaveIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_HistoryIcon = _resolveComponent("HistoryIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_PackageIcon = _resolveComponent("PackageIcon");
    const _component_LayersIcon = _resolveComponent("LayersIcon");
    const _component_AwardIcon = _resolveComponent("AwardIcon");
    const _component_CalendarIcon = _resolveComponent("CalendarIcon");
    const _component_PowerIcon = _resolveComponent("PowerIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_HashIcon = _resolveComponent("HashIcon");
    const _component_PercentIcon = _resolveComponent("PercentIcon");
    const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" ── Page Header ── "),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_TagIcon, { size: 26 })
                        ]),
                        _hoisted_7
                    ])
                ]),
                _createCommentVNode(" ── TOOLBAR ── "),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.activeTab = 'grilla')),
                            class: _normalizeClass(['pm-tab', { active: _ctx.activeTab === 'grilla' }])
                        }, [
                            _createVNode(_component_TagIcon, { size: 16 }),
                            _createTextVNode(" Grilla de Precios ")
                        ], 2 /* CLASS */),
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.activeTab = 'promos')),
                            class: _normalizeClass(['pm-tab', { active: _ctx.activeTab === 'promos' }])
                        }, [
                            _createVNode(_component_BadgePercentIcon, { size: 16 }),
                            _createTextVNode(" Promociones ")
                        ], 2 /* CLASS */)
                    ]),
                    _createCommentVNode(" Grilla Controls "),
                    _withDirectives(_createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_SearchIcon, {
                                size: 15,
                                class: "pm-search-ico"
                            }),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.filtro.busqueda) = $event)),
                                placeholder: "Buscar producto o equivalente...",
                                class: "pm-search-input",
                                onKeyup: _cache[3] || (_cache[3] = _withKeys(
                                //@ts-ignore
                                (...args) => (_ctx.loadGrilla && _ctx.loadGrilla(...args)), ["enter"]))
                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                [_vModelText, _ctx.filtro.busqueda]
                            ])
                        ]),
                        (_ctx.canEdit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _hoisted_13,
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.config.porcentajeUtilidadMayor) = $event)),
                                    class: "pm-config-input",
                                    min: "0",
                                    step: "0.1"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.config.porcentajeUtilidadMayor]
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[5] || (_cache[5] =
                                        //@ts-ignore
                                        (...args) => (_ctx.saveConfig && _ctx.saveConfig(...args))),
                                    disabled: _ctx.isSavingConfig,
                                    class: "pm-btn-save"
                                }, [
                                    (!_ctx.isSavingConfig)
                                        ? (_openBlock(), _createBlock(_component_SaveIcon, {
                                            key: 0,
                                            size: 15
                                        }))
                                        : (_openBlock(), _createBlock(_component_Loader2Icon, {
                                            key: 1,
                                            class: "spinner-icon",
                                            size: 15
                                        }))
                                ], 8 /* PROPS */, _hoisted_14)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.filtroPVD) = $event)),
                                class: "pm-config-input",
                                style: { "width": "auto", "padding": "6px 10px", "cursor": "pointer" }
                            }, _hoisted_22, 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.filtroPVD]
                            ])
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => (_ctx.loadGrilla && _ctx.loadGrilla(...args))),
                            class: "pm-btn-refresh"
                        }, [
                            _createVNode(_component_SearchIcon, { size: 15 })
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.activeTab === 'grilla']
                    ]),
                    _createCommentVNode(" Promo Controls "),
                    _withDirectives(_createElementVNode("div", _hoisted_23, [
                        (_ctx.canManagePromos)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.openPromoModal())),
                                class: "pm-btn-add"
                            }, [
                                _createVNode(_component_PlusIcon, { size: 15 }),
                                _createTextVNode(" Nueva Promoción ")
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.activeTab === 'promos']
                    ])
                ]),
                _createCommentVNode(" VISTA GRILLA "),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("table", _hoisted_25, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _hoisted_26,
                                    _hoisted_27,
                                    _hoisted_28,
                                    _hoisted_29,
                                    _hoisted_30,
                                    _hoisted_31,
                                    _hoisted_32,
                                    _hoisted_33,
                                    _hoisted_34,
                                    _hoisted_35,
                                    _createElementVNode("th", _hoisted_36, "PVD (" + _toDisplayString(_ctx.filtroPVD) + "D)", 1 /* TEXT */)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_ctx.isLoadingGrilla)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                                        _createElementVNode("td", _hoisted_38, [
                                            _createElementVNode("div", _hoisted_39, [
                                                _createVNode(_component_Loader2Icon, {
                                                    class: "spinner-icon text-primary",
                                                    size: 32
                                                }),
                                                _hoisted_40
                                            ])
                                        ])
                                    ]))
                                    : (!_ctx.grilla.items || _ctx.grilla.items.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_41, _hoisted_43))
                                        : _createCommentVNode("v-if", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grilla.items, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: item.productoId
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_44, _toDisplayString(item.nombre), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_45, _toDisplayString(item.codigoUnico), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("td", null, [
                                            (item.codigoEquivalente)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(item.codigoEquivalente), 1 /* TEXT */))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_47, "-"))
                                        ]),
                                        _createElementVNode("td", _hoisted_48, [
                                            _createElementVNode("span", _hoisted_49, _toDisplayString(item.stockTotal), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("td", _hoisted_50, " $" + _toDisplayString(_ctx.formatNumber(item.ultimoCosto)), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                                _createTextVNode(" $" + _toDisplayString(_ctx.formatNumber(item.costoPromedio)) + " ", 1 /* TEXT */),
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (_ctx.openHistory(item.productoId, item.nombre)),
                                                    class: "pm-icon-btn",
                                                    style: { "width": "24px", "height": "24px", "color": "#64748b", "background": "transparent", "border": "1px solid #e2e8f0" },
                                                    title: "Ver historial de costos"
                                                }, [
                                                    _createVNode(_component_HistoryIcon, { size: 14 })
                                                ], 8 /* PROPS */, _hoisted_53)
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_54, [
                                            (item.equivalenteId)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event) => ((item.porcentajeUtilidadDetal) = $event),
                                                        onChange: ($event) => (_ctx.updateUtilidad(item)),
                                                        disabled: !_ctx.canEdit,
                                                        style: { "width": "60px", "text-align": "center", "padding": "2px", "border": "1px solid #bbf7d0", "border-radius": "4px", "background": "white", "color": "#166534", "font-weight": "bold", "font-size": "0.85rem" },
                                                        min: "0",
                                                        step: "0.1"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_56), [
                                                        [_vModelText, item.porcentajeUtilidadDetal]
                                                    ])
                                                ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_57, "-"))
                                        ]),
                                        _createElementVNode("td", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                                (item.porcentajePromocion)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, " -" + _toDisplayString(item.porcentajePromocion) + "% ", 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("span", {
                                                    style: _normalizeStyle([item.porcentajePromocion ? 'text-decoration: line-through; color: #94a3b8; font-size: 0.75rem;' : 'font-weight: 700; color: #15803d; font-size: 0.85rem;', { "font-family": "monospace" }])
                                                }, " $" + _toDisplayString(_ctx.formatNumber(item.precioDetal)), 5 /* TEXT, STYLE */),
                                                (item.porcentajePromocion)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_61, " $" + _toDisplayString(_ctx.formatNumber(item.precioDetalConPromocion)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_62, [
                                            _createElementVNode("span", _hoisted_63, " $" + _toDisplayString(_ctx.formatNumber(item.precioAliado)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("td", _hoisted_64, [
                                            _createElementVNode("span", _hoisted_65, " $" + _toDisplayString(_ctx.formatNumber(item.precioMayor)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("td", _hoisted_66, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["pvd-box-simple", { 'has-sales': _ctx.getValPVD(item) > 0 }])
                                            }, _toDisplayString(_ctx.formatNumber(_ctx.getValPVD(item))), 3 /* TEXT, CLASS */)
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ])
                    ]),
                    (_ctx.grilla.totalPaginas > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("button", {
                                onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.changePage(_ctx.filtro.pagina - 1))),
                                disabled: _ctx.filtro.pagina === 1,
                                class: "pm-page-btn"
                            }, [
                                _createVNode(_component_ChevronLeftIcon, { size: 15 }),
                                _createTextVNode(" Anterior ")
                            ], 8 /* PROPS */, _hoisted_68),
                            _createElementVNode("span", _hoisted_69, [
                                _createTextVNode("Página "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.filtro.pagina), 1 /* TEXT */),
                                _createTextVNode(" de "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.grilla.totalPaginas), 1 /* TEXT */)
                            ]),
                            _createElementVNode("button", {
                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.changePage(_ctx.filtro.pagina + 1))),
                                disabled: _ctx.filtro.pagina === _ctx.grilla.totalPaginas,
                                class: "pm-page-btn"
                            }, [
                                _createTextVNode(" Siguiente "),
                                _createVNode(_component_ChevronRightIcon, { size: 15 })
                            ], 8 /* PROPS */, _hoisted_70)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_71, "Total Productos: " + _toDisplayString(_ctx.grilla.totalItems || 0), 1 /* TEXT */)
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.activeTab === 'grilla']
                ]),
                _createCommentVNode(" VISTA PROMOS "),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                                _createVNode(_component_SearchIcon, {
                                    size: 15,
                                    class: "pm-search-ico"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.filterPromoQuery) = $event)),
                                    onInput: _cache[12] || (_cache[12] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onFilterPromoInput && _ctx.onFilterPromoInput(...args))),
                                    placeholder: "Filtrar por Producto o Equivalente...",
                                    class: "pm-search-input",
                                    style: { "width": "320px" },
                                    onFocus: _cache[13] || (_cache[13] = ($event) => (_ctx.showFilterPromoDropdown = true))
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelText, _ctx.filterPromoQuery]
                                ]),
                                (_ctx.showFilterPromoDropdown && _ctx.filterPromoResults.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_75, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterPromoResults, (res) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: res.key,
                                                class: "ac-option",
                                                onMousedown: _withModifiers(($event) => (_ctx.selectFilterPromoTarget(res)), ["prevent"])
                                            }, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(['pm-badge', res.tipo === 'producto' ? 'pm-badge-blue' : (res.tipo === 'marca' ? 'pm-badge-green' : 'pm-badge-pink')]),
                                                    style: { "font-size": "0.6rem", "padding": "1px 4px", "margin-right": "8px" }
                                                }, _toDisplayString(res.tipo === 'producto' ? 'PRD' : (res.tipo === 'marca' ? 'MAR' : 'EQV')), 3 /* TEXT, CLASS */),
                                                _createTextVNode(" " + _toDisplayString(res.nombre), 1 /* TEXT */)
                                            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_76));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("label", _hoisted_77, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    id: "soloActivasPromo",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.filtroPromo.soloActivas) = $event)),
                                    onChange: _cache[15] || (_cache[15] =
                                        //@ts-ignore
                                        (...args) => (_ctx.loadPromociones && _ctx.loadPromociones(...args))),
                                    class: "pm-checkbox"
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelCheckbox, _ctx.filtroPromo.soloActivas]
                                ]),
                                _createTextVNode(" Solo Vigentes ")
                            ]),
                            _createElementVNode("button", {
                                class: "pm-btn-save",
                                onClick: _cache[16] || (_cache[16] =
                                    //@ts-ignore
                                    (...args) => (_ctx.loadPromociones && _ctx.loadPromociones(...args)))
                            }, [
                                _createVNode(_component_SearchIcon, { size: 15 }),
                                _createTextVNode(" Buscar ")
                            ])
                        ]),
                        _createElementVNode("table", _hoisted_78, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _hoisted_79,
                                    _hoisted_80,
                                    _hoisted_81,
                                    _hoisted_82,
                                    _hoisted_83,
                                    _hoisted_84,
                                    (_ctx.canManagePromos)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_85, "Acciones"))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_ctx.isLoadingPromos)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_86, [
                                        _createElementVNode("td", _hoisted_87, [
                                            _createVNode(_component_Loader2Icon, {
                                                class: "spinner-icon",
                                                size: 30,
                                                style: { "color": "#3b82f6" }
                                            }),
                                            _hoisted_88
                                        ])
                                    ]))
                                    : (_ctx.promociones.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_89, [
                                            _createElementVNode("td", _hoisted_90, [
                                                _createVNode(_component_BadgePercentIcon, {
                                                    size: 36,
                                                    style: { "color": "#cbd5e1" }
                                                }),
                                                _hoisted_91
                                            ])
                                        ]))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.promociones, (promo) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: promo.id,
                                                class: "pm-tr-hover"
                                            }, [
                                                _createElementVNode("td", null, [
                                                    (promo.productoId)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_92, [
                                                            _createVNode(_component_PackageIcon, { size: 10 }),
                                                            _createTextVNode(" Producto")
                                                        ]))
                                                        : (promo.equivalenteId)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_93, [
                                                                _createVNode(_component_LayersIcon, { size: 10 }),
                                                                _createTextVNode(" Equivalente")
                                                            ]))
                                                            : (promo.marcaValorId)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_94, [
                                                                    _createVNode(_component_AwardIcon, { size: 10 }),
                                                                    _createTextVNode(" Marca")
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_95, [
                                                        (promo.productoId)
                                                            ? (_openBlock(), _createBlock(_component_PackageIcon, {
                                                                key: 0,
                                                                size: 14,
                                                                style: { "color": "#64748b" }
                                                            }))
                                                            : (promo.equivalenteId)
                                                                ? (_openBlock(), _createBlock(_component_LayersIcon, {
                                                                    key: 1,
                                                                    size: 14,
                                                                    style: { "color": "#64748b" }
                                                                }))
                                                                : (_openBlock(), _createBlock(_component_AwardIcon, {
                                                                    key: 2,
                                                                    size: 14,
                                                                    style: { "color": "#64748b" }
                                                                })),
                                                        _createElementVNode("span", _hoisted_96, _toDisplayString(promo.productoNombre || promo.equivalenteCodigo || promo.marcaValorNombre), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_97, [
                                                    _createElementVNode("div", _hoisted_98, "-" + _toDisplayString(promo.porcentajeDescuento) + "%", 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_99, [
                                                        _createVNode(_component_CalendarIcon, {
                                                            size: 12,
                                                            style: { "display": "inline", "margin-top": "-2px" }
                                                        }),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(promo.fechaInicio)), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_100, [
                                                        _createVNode(_component_CalendarIcon, {
                                                            size: 12,
                                                            style: { "display": "inline", "margin-top": "-2px" }
                                                        }),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(promo.fechaFin)), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createElementVNode("td", null, [
                                                    (promo.estaVigente)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                                                            _hoisted_102,
                                                            _createTextVNode(" Vigente ")
                                                        ]))
                                                        : (!promo.activo)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_103, "Inactiva"))
                                                            : (new Date(promo.fechaInicio) > new Date())
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_104, "Programada"))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_105, "Expirada"))
                                                ]),
                                                (_ctx.canManagePromos)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_106, [
                                                        _createElementVNode("button", {
                                                            class: "pm-icon-btn btn-toggle",
                                                            onClick: ($event) => (_ctx.togglePromo(promo.id)),
                                                            title: promo.activo ? 'Desactivar' : 'Activar'
                                                        }, [
                                                            _createVNode(_component_PowerIcon, {
                                                                size: 18,
                                                                class: _normalizeClass(promo.activo ? 'text-success' : 'text-danger')
                                                            }, null, 8 /* PROPS */, ["class"])
                                                        ], 8 /* PROPS */, _hoisted_107),
                                                        _createElementVNode("button", {
                                                            class: "pm-icon-btn pm-icon-edit",
                                                            onClick: ($event) => (_ctx.openPromoModal(promo)),
                                                            title: "Editar Fechas"
                                                        }, [
                                                            _createVNode(_component_EditIcon, { size: 15 })
                                                        ], 8 /* PROPS */, _hoisted_108),
                                                        _createElementVNode("button", {
                                                            class: "pm-icon-btn pm-icon-del",
                                                            onClick: ($event) => (_ctx.deletePromo(promo.id)),
                                                            title: "Eliminar"
                                                        }, [
                                                            _createVNode(_component_TrashIcon, { size: 15 })
                                                        ], 8 /* PROPS */, _hoisted_109)
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ])
                    ]),
                    (_ctx.promosMeta.totalPaginas > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                            _createElementVNode("button", {
                                onClick: _cache[17] || (_cache[17] = ($event) => (_ctx.changePagePromo(_ctx.filtroPromo.pagina - 1))),
                                disabled: _ctx.filtroPromo.pagina === 1,
                                class: "pm-page-btn"
                            }, [
                                _createVNode(_component_ChevronLeftIcon, { size: 15 }),
                                _createTextVNode(" Anterior ")
                            ], 8 /* PROPS */, _hoisted_111),
                            _createElementVNode("span", _hoisted_112, [
                                _createTextVNode("Página "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.filtroPromo.pagina), 1 /* TEXT */),
                                _createTextVNode(" de "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.promosMeta.totalPaginas), 1 /* TEXT */)
                            ]),
                            _createElementVNode("button", {
                                onClick: _cache[18] || (_cache[18] = ($event) => (_ctx.changePagePromo(_ctx.filtroPromo.pagina + 1))),
                                disabled: _ctx.filtroPromo.pagina === _ctx.promosMeta.totalPaginas,
                                class: "pm-page-btn"
                            }, [
                                _createTextVNode(" Siguiente "),
                                _createVNode(_component_ChevronRightIcon, { size: 15 })
                            ], 8 /* PROPS */, _hoisted_113)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_114, "Total Promociones: " + _toDisplayString(_ctx.promosMeta.totalItems || 0), 1 /* TEXT */)
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.activeTab === 'promos']
                ])
            ])
        ]),
        _createCommentVNode(" MODAL PROMOCIONES (ESTILO RETAIL) "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                (_ctx.showPromoModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("div", _hoisted_118, [
                                    _createElementVNode("div", _hoisted_119, [
                                        _createVNode(_component_BadgePercentIcon, { size: 24 })
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h2", _hoisted_120, _toDisplayString(_ctx.promoForm.id ? 'Editar Promoción' : 'Nueva Promoción'), 1 /* TEXT */),
                                        _hoisted_121
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[19] || (_cache[19] = ($event) => (_ctx.showPromoModal = false)),
                                    style: { "background": "#f8fafc", "border": "none", "width": "40px", "height": "40px", "border-radius": "10px", "display": "flex", "align-items": "center", "justify-content": "center", "cursor": "pointer", "color": "#94a3b8", "transition": "all 0.2s" }
                                }, [
                                    _createVNode(_component_XIcon, { size: 20 })
                                ])
                            ]),
                            _createElementVNode("form", {
                                onSubmit: _cache[32] || (_cache[32] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.savePromo && _ctx.savePromo(...args)), ["prevent"])),
                                class: "modal-body bg-light-premium p-0 m-0"
                            }, [
                                _createElementVNode("div", _hoisted_122, [
                                    _createElementVNode("div", _hoisted_123, [
                                        _hoisted_124,
                                        _createElementVNode("div", _hoisted_125, [
                                            _createElementVNode("div", _hoisted_126, [
                                                _hoisted_127,
                                                _createElementVNode("div", _hoisted_128, [
                                                    _createElementVNode("label", {
                                                        style: _normalizeStyle([{ "display": "flex", "flex-direction": "column", "align-items": "center", "text-align": "center", "gap": "8px", "background": "white", "padding": "12px", "border": "1px solid #e2e8f0", "border-radius": "14px", "cursor": "pointer", "transition": "all 0.2s" }, [_ctx.applyType === 'producto' ? 'border-color: #3b82f6; background: #f0f7ff; box-shadow: 0 4px 6px -1px rgba(59,130,246,0.05);' : '']])
                                                    }, [
                                                        _createElementVNode("div", _hoisted_129, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "radio",
                                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.applyType) = $event)),
                                                                value: "producto",
                                                                style: { "width": "16px", "height": "16px", "accent-color": "#3b82f6" },
                                                                disabled: _ctx.promoForm.id != null
                                                            }, null, 8 /* PROPS */, _hoisted_130), [
                                                                [_vModelRadio, _ctx.applyType]
                                                            ]),
                                                            _createVNode(_component_PackageIcon, {
                                                                size: 16,
                                                                style: _normalizeStyle({ color: _ctx.applyType === 'producto' ? '#3b82f6' : '#64748b' })
                                                            }, null, 8 /* PROPS */, ["style"])
                                                        ]),
                                                        _hoisted_131
                                                    ], 4 /* STYLE */),
                                                    _createElementVNode("label", {
                                                        style: _normalizeStyle([{ "display": "flex", "flex-direction": "column", "align-items": "center", "text-align": "center", "gap": "8px", "background": "white", "padding": "12px", "border": "1px solid #e2e8f0", "border-radius": "14px", "cursor": "pointer", "transition": "all 0.2s" }, [_ctx.applyType === 'equivalente' ? 'border-color: #ec4899; background: #fdf2f8; box-shadow: 0 4px 6px -1px rgba(236,72,153,0.05);' : '']])
                                                    }, [
                                                        _createElementVNode("div", _hoisted_132, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "radio",
                                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.applyType) = $event)),
                                                                value: "equivalente",
                                                                style: { "width": "16px", "height": "16px", "accent-color": "#ec4899" },
                                                                disabled: _ctx.promoForm.id != null
                                                            }, null, 8 /* PROPS */, _hoisted_133), [
                                                                [_vModelRadio, _ctx.applyType]
                                                            ]),
                                                            _createVNode(_component_LayersIcon, {
                                                                size: 16,
                                                                style: _normalizeStyle({ color: _ctx.applyType === 'equivalente' ? '#ec4899' : '#64748b' })
                                                            }, null, 8 /* PROPS */, ["style"])
                                                        ]),
                                                        _hoisted_134
                                                    ], 4 /* STYLE */),
                                                    _createElementVNode("label", {
                                                        style: _normalizeStyle([{ "display": "flex", "flex-direction": "column", "align-items": "center", "text-align": "center", "gap": "8px", "background": "white", "padding": "12px", "border": "1px solid #e2e8f0", "border-radius": "14px", "cursor": "pointer", "transition": "all 0.2s" }, [_ctx.applyType === 'marca' ? 'border-color: #10b981; background: #f0fdf4; box-shadow: 0 4px 6px -1px rgba(16,185,129,0.05);' : '']])
                                                    }, [
                                                        _createElementVNode("div", _hoisted_135, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "radio",
                                                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.applyType) = $event)),
                                                                value: "marca",
                                                                style: { "width": "16px", "height": "16px", "accent-color": "#10b981" },
                                                                disabled: _ctx.promoForm.id != null
                                                            }, null, 8 /* PROPS */, _hoisted_136), [
                                                                [_vModelRadio, _ctx.applyType]
                                                            ]),
                                                            _createVNode(_component_AwardIcon, {
                                                                size: 16,
                                                                style: _normalizeStyle({ color: _ctx.applyType === 'marca' ? '#10b981' : '#64748b' })
                                                            }, null, 8 /* PROPS */, ["style"])
                                                        ]),
                                                        _hoisted_137
                                                    ], 4 /* STYLE */)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_138, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_HashIcon, { size: 14 }),
                                                    _createTextVNode(" Buscar " + _toDisplayString(_ctx.applyType === 'producto' ? 'Producto' : (_ctx.applyType === 'marca' ?
                                                        'Marca' : 'Equivalente')), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["autocomplete-wrap", { 'is-selected': _ctx.targetSeleccionado }]),
                                                    style: { "padding": "12px 16px", "border-radius": "14px" }
                                                }, [
                                                    _createVNode(_component_SearchIcon, {
                                                        size: 18,
                                                        class: "ac-icon"
                                                    }),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.searchTargetQuery) = $event)),
                                                        onInput: _cache[24] || (_cache[24] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.onSearchTargetInput && _ctx.onSearchTargetInput(...args))),
                                                        class: _normalizeClass(["ac-input", { 'selected': _ctx.targetSeleccionado }]),
                                                        style: { "font-size": "1rem", "padding": "4px 8px" },
                                                        placeholder: `Escriba para buscar por nombre o código...`,
                                                        onFocus: _cache[25] || (_cache[25] = ($event) => (_ctx.showTargetDropdown = true)),
                                                        onBlur: _cache[26] || (_cache[26] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.hideTargetDropdown && _ctx.hideTargetDropdown(...args))),
                                                        required: "",
                                                        disabled: _ctx.promoForm.id != null
                                                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_139), [
                                                        [_vModelText, _ctx.searchTargetQuery]
                                                    ])
                                                ], 2 /* CLASS */),
                                                (_ctx.showTargetDropdown && _ctx.searchResults.length > 0)
                                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_140, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (res) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                                key: res.id,
                                                                class: "ac-option",
                                                                onMousedown: _withModifiers(($event) => (_ctx.seleccionarTarget(res.id, res.nombre)), ["prevent"])
                                                            }, [
                                                                (_ctx.applyType === 'producto')
                                                                    ? (_openBlock(), _createBlock(_component_PackageIcon, {
                                                                        key: 0,
                                                                        size: 13
                                                                    }))
                                                                    : (_ctx.applyType === 'equivalente')
                                                                        ? (_openBlock(), _createBlock(_component_LayersIcon, {
                                                                            key: 1,
                                                                            size: 13
                                                                        }))
                                                                        : (_openBlock(), _createBlock(_component_AwardIcon, {
                                                                            key: 2,
                                                                            size: 13
                                                                        })),
                                                                _createTextVNode(" " + _toDisplayString(res.nombre), 1 /* TEXT */)
                                                            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_141));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createCommentVNode(" FILA 3: VALOR DEL DESCUENTO (PRINCIPAL) "),
                                            _createElementVNode("div", _hoisted_142, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_PercentIcon, { size: 14 }),
                                                    _createTextVNode(" Porcentaje de Descuento ")
                                                ]),
                                                _createElementVNode("div", _hoisted_143, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.promoForm.porcentajeDescuento) = $event)),
                                                        placeholder: "0.00",
                                                        required: "",
                                                        min: "1",
                                                        max: "99",
                                                        step: "0.1",
                                                        style: _normalizeStyle([{ "color": "#ef4444", "font-weight": "900", "font-size": "1.2rem", "padding-right": "45px" }, _ctx.promoForm.id ? 'opacity: 0.6; cursor: not-allowed;' : '']),
                                                        disabled: _ctx.promoForm.id != null
                                                    }, null, 12 /* STYLE, PROPS */, _hoisted_144), [
                                                        [_vModelText, _ctx.promoForm.porcentajeDescuento]
                                                    ]),
                                                    _hoisted_145
                                                ]),
                                                _hoisted_146
                                            ]),
                                            _createCommentVNode(" FILA 4: VIGENCIA (FECHAS LADO A LADO) "),
                                            _createElementVNode("div", _hoisted_147, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_CalendarIcon, { size: 14 }),
                                                    _createTextVNode(" Fecha de Inicio ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.promoForm.fechaInicio) = $event)),
                                                    required: "",
                                                    style: { "font-weight": "600", "color": "#334155" }
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, _ctx.promoForm.fechaInicio]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_148, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_CalendarIcon, { size: 14 }),
                                                    _createTextVNode(" Fecha de Finalización ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.promoForm.fechaFin) = $event)),
                                                    required: "",
                                                    style: { "font-weight": "600", "color": "#334155" }
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, _ctx.promoForm.fechaFin]
                                                ])
                                            ]),
                                            _createCommentVNode(" FILA 5: ESTADO "),
                                            _createElementVNode("div", _hoisted_149, [
                                                _createElementVNode("label", {
                                                    style: _normalizeStyle([{ "display": "flex", "align-items": "center", "gap": "12px", "cursor": "pointer", "background": "#f8fafc", "padding": "16px", "border-radius": "16px", "border": "2px solid #e2e8f0", "transition": "all 0.2s" }, _ctx.promoForm.activo ? 'border-color: #10b981; background: #f0fdf4;' : ''])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((_ctx.promoForm.activo) = $event)),
                                                        style: { "width": "22px", "height": "22px", "accent-color": "#10b981", "cursor": "pointer" }
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelCheckbox, _ctx.promoForm.activo]
                                                    ]),
                                                    _hoisted_150
                                                ], 4 /* STYLE */)
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[31] || (_cache[31] = ($event) => (_ctx.showPromoModal = false)),
                                        style: { "padding": "10px 20px", "border-radius": "10px", "border": "1px solid #e2e8f0", "background": "white", "color": "#64748b", "font-weight": "600", "cursor": "pointer", "transition": "all 0.2s" }
                                    }, "Cancelar"),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        disabled: _ctx.isSavingPromo,
                                        style: { "padding": "10px 32px", "border-radius": "10px", "border": "none", "background": "#2563eb", "color": "white", "font-weight": "700", "cursor": "pointer", "transition": "all 0.2s", "box-shadow": "0 4px 12px rgba(37,99,235,0.2)" }
                                    }, [
                                        (_ctx.isSavingPromo)
                                            ? (_openBlock(), _createBlock(_component_Loader2Icon, {
                                                key: 0,
                                                class: "spinner-icon",
                                                size: 20
                                            }))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_153, _toDisplayString(_ctx.promoForm.id ? 'Actualizar' : 'Crear Promoción'), 1 /* TEXT */))
                                    ], 8 /* PROPS */, _hoisted_152)
                                ])
                            ], 32 /* NEED_HYDRATION */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }),
        _createCommentVNode(" MODAL HISTORIAL DE COSTOS "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                (_ctx.showHistoryModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                        _createElementVNode("div", _hoisted_155, [
                            _createElementVNode("div", _hoisted_156, [
                                _createElementVNode("div", _hoisted_157, [
                                    _createElementVNode("div", _hoisted_158, [
                                        _createVNode(_component_HistoryIcon, { size: 22 })
                                    ]),
                                    _createElementVNode("div", null, [
                                        _hoisted_159,
                                        _createElementVNode("p", _hoisted_160, _toDisplayString(_ctx.historyProductName), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[33] || (_cache[33] = ($event) => (_ctx.showHistoryModal = false)),
                                    class: "pm-icon-btn"
                                }, [
                                    _createVNode(_component_XIcon, { size: 20 })
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_161, [
                                (_ctx.isLoadingHistory)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                        _createVNode(_component_Loader2Icon, {
                                            class: "spinner-icon",
                                            size: 32,
                                            style: { "color": "#3b82f6" }
                                        }),
                                        _hoisted_163
                                    ]))
                                    : (_ctx.historyData.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                            _createVNode(_component_HistoryIcon, {
                                                size: 48,
                                                style: { "color": "#cbd5e1", "margin-bottom": "1rem" }
                                            }),
                                            _hoisted_165
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                            _createElementVNode("table", _hoisted_167, [
                                                _hoisted_168,
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyData, (h) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: h.id,
                                                            class: "pm-tr-hover"
                                                        }, [
                                                            _createElementVNode("td", _hoisted_169, [
                                                                _createElementVNode("div", _hoisted_170, _toDisplayString(_ctx.formatDate(h.fecha)), 1 /* TEXT */),
                                                                _createElementVNode("div", _hoisted_171, _toDisplayString(_ctx.formatTime(h.fecha)), 1 /* TEXT */)
                                                            ]),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(['pm-badge', h.tipoCosto === 'PROMEDIO' ? 'pm-badge-blue' : 'pm-badge-green']),
                                                                    style: { "font-size": "0.65rem" }
                                                                }, _toDisplayString(h.tipoCosto), 3 /* TEXT, CLASS */)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_172, " $" + _toDisplayString(_ctx.formatNumber(h.costoAnterior)), 1 /* TEXT */),
                                                            _createElementVNode("td", _hoisted_173, [
                                                                _createVNode(_component_ArrowRightIcon, { size: 12 })
                                                            ]),
                                                            _createElementVNode("td", _hoisted_174, " $" + _toDisplayString(_ctx.formatNumber(h.costoNuevo)), 1 /* TEXT */),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("div", _hoisted_175, _toDisplayString(h.referenciaDocumento), 1 /* TEXT */),
                                                                _createElementVNode("div", _hoisted_176, _toDisplayString(h.notas), 1 /* TEXT */)
                                                            ]),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("div", _hoisted_177, [
                                                                    _createElementVNode("div", _hoisted_178, _toDisplayString((h.usuario || 'S')[0]), 1 /* TEXT */),
                                                                    _createElementVNode("span", _hoisted_179, _toDisplayString(h.usuario || 'Sistema'), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ])
                                            ])
                                        ]))
                            ]),
                            _createElementVNode("div", _hoisted_180, [
                                _createElementVNode("button", {
                                    onClick: _cache[34] || (_cache[34] = ($event) => (_ctx.showHistoryModal = false)),
                                    class: "pm-btn-save",
                                    style: { "background": "#0f172a" }
                                }, "Cerrar")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
